import { Action } from '@ngrx/store';
import { TurnosAsignados } from '../../../../models/turnos-asignados/turnos-asignados.models';

export const SET_TURNOS_ASIGNADOS = '[Ingresar turnos asignados] Set turnos asignados';
export const UNSET_TURNOS_ASIGNADOS = '[Eliminar turnos asignados] UnSet turnos asignados';


export class SetTurnosAsignadosAction implements Action {
    readonly type = SET_TURNOS_ASIGNADOS;

    constructor(public turnosAsignados: TurnosAsignados) {}
}

export class UnsetTurnosAsignadosAction implements Action {
    readonly type = UNSET_TURNOS_ASIGNADOS;
}

export type acciones = SetTurnosAsignadosAction
                       | UnsetTurnosAsignadosAction;


// WEBPACK FOOTER //
// ./src/pages/meseromesero/state/turnos-asignados/turnos-asignados-accions.ts